// processing_warning_utils.js - Shared utilities for processing episode warning modal

/**
 * Check if episode is processing and show warning modal
 * @param {Object} alpine - The Alpine component instance
 */
export function checkProcessingWarning(alpine) {
    const dataEl = document.getElementById("ql-data-points");
    if (dataEl && dataEl.dataset.isProcessing === 'true') {
        alpine.processing_warning_modal = true;
        document.body.classList.add('overflow-hidden');
    }
}

/**
 * Convert a processing episode to draft state
 * @param {Object} alpine - The Alpine component instance
 */
export async function convertProcessingToDraft(alpine) {
    alpine.is_converting_to_draft = true;
    const dataEl = document.getElementById("ql-data-points");
    const showId = dataEl.dataset.showId;
    const episodeId = dataEl.dataset.episodeId;

    try {
        const response = await fetch(`/shows/${showId}/episodes/${episodeId}/convert-processing-to-draft`, {
            method: 'POST',
            headers: {
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
                'Content-Type': 'application/json'
            }
        });

        if (response.ok) {
            document.body.classList.remove('overflow-hidden');
            window.location.reload();
        } else {
            // Check if episode is no longer processing (race condition)
            const data = await response.json();
            if (data.error === 'Episode is not processing') {
                // Episode finished processing while modal was open - just reload
                document.body.classList.remove('overflow-hidden');
                window.location.reload();
            } else {
                alert('Failed to convert episode. Please try again.');
                alpine.is_converting_to_draft = false;
            }
        }
    } catch (e) {
        alert('Failed to convert episode. Please try again.');
        alpine.is_converting_to_draft = false;
    }
}

/**
 * Cancel the processing warning and navigate back
 */
export function cancelProcessingWarning() {
    document.body.classList.remove('overflow-hidden');
    const dataEl = document.getElementById("ql-data-points");
    window.location.href = dataEl.dataset.successUrl;
}
